import { BeginWidget } from "./begin.js";

export class BeginTheoremWidget extends BeginWidget {
    constructor(environment, name, argumentText = "") {
        super(environment);
        this.name = name;
        this.argumentText = argumentText;
    }

    toDOM(view) {
        const element = super.toDOM(view);
        element.classList.add("ol-cm-begin-theorem");
        return element;
    }

    updateDOM(element, view) {
        super.updateDOM(element, view);
        element.classList.add("ol-cm-begin-theorem");
        return true;
    }

    eq(widget) {
        return super.eq(widget) && widget.name === this.name && widget.argumentText === this.argumentText;
    }

    buildName(nameElement) {
        nameElement.textContent = this.name;
        if (this.argumentText) {
            const suffix = document.createElement("span");
            suffix.textContent = ` (${this.argumentText})`;
            nameElement.appendChild(suffix);
        }
    }
}
